import { fetchGetStateByStateKey } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../../iwQueryClient/useStateKey';

export const useGetNotTopUpEligibleData = () => {
    const stateKey = useStateKey();

    const { data: companyName } = useQuery({
        queryKey: ['customer_state', stateKey],
        queryFn: () => fetchGetStateByStateKey({ stateKey }),
        select: ({ data }) =>
            data.application!.company!.registered_company_name,
        suspense: true
    });

    return { companyName: companyName! };
};
